import { Appointment } from "./types";

// An appointment can reference multiple distinct customers/patients (a
// guardian, an "other person" booker, several patients) via
// appointment_customer_details/appointment_patient_details — if ANY of them
// is mid-merge, the whole appointment screen locks (matches the customer/
// patient drawer's own merge_status='pending' full-screen lock, E1).
const getIsAppointmentMergeLocked = (appointment: Appointment): boolean => {
  const acdLocked = appointment.appointment_customer_details.some(
    (acd) => acd.customer?.merge_status === "pending",
  );
  const apdLocked = appointment.appointment_patient_details.some(
    (apd) =>
      apd.customer?.merge_status === "pending" ||
      apd.patient?.merge_status === "pending",
  );

  return acdLocked || apdLocked;
};

export default getIsAppointmentMergeLocked;
